module.exports = __webpack_public_path__ + "img/logo_dorapp--wh.27d75344.svg";